import { useEntityTypeRegistry } from './entity-type-registry';

export interface ResolveEntityLinkInput {
  entityType?: string;
  entityId?: string;
  explicitUrl?: string;
  fallbackUrl?: string;
}

export function resolveEntityLink(input: ResolveEntityLinkInput): string | undefined {
  if (input.explicitUrl) return input.explicitUrl;

  if (input.entityType) {
    const route = useEntityTypeRegistry.getState().getEntityRouteForId(input.entityType, input.entityId);
    if (route) return route;
  }

  if (input.fallbackUrl) return input.fallbackUrl;

  if (input.entityId) return `/entity/${input.entityId}`;
  return undefined;
}
